import { render, staticRenderFns } from "./Egresos.vue?vue&type=template&id=af2fe616&"
import script from "./Egresos.vue?vue&type=script&lang=js&"
export * from "./Egresos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports